import React from 'react';
import classNames from 'classnames';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/components/textWithIconStyle';

interface IPackages {
	items: Array<string>;
	displayInline?: boolean;
}
export const TextWithIcon = ({ items, displayInline = false }: IPackages) => {
	//@ts-ignore
	const useStyles = makeStyles(styles);
	const classes = useStyles();

	return (
		<div className={classNames({ [classes.packageWrapper]: true, [classes.displayInline]: displayInline })}>
			{items.map((item: any, index) => {
				return (
					<div key={index} className={classes.packageDiv}>
						<CheckCircleOutlineIcon className={classes.circle} />
						<div className={classes.packageName}>{item}</div>
					</div>
				);
			})}
		</div>
	);
};
